<template>
    <h1 class="title">
        <slot/>
    </h1>
</template>

<script>
    export default {
        name: "Title"
    }
</script>

<style lang="scss">
    .title {
        font-size: 2.8rem;
        font-weight: normal;

        margin-bottom: 4rem;
        line-height: 3.6rem;
    }
</style>